export enum DataLayerEventsEnum {
  ISAddBondClick = 'is_add_bond_click',
  ISSearchMyBondsJames = 'is_search_my_bonds_james',
  ISBondsSyncOnDone = 'is_bonds_sync_on_done',
  ISSearchISsueManually = 'is_search_issue_manually',
  ISChooseIssueManually = 'is_choose_issue_manually',
  ISBackManualAdd = 'is_back_manual_add',
  ISAddIssueManuallyDone = 'is_add_issue_manually_done',
  ISTurnBondsSyncOff = 'is_turn_bonds_sync_off',
  ISTurnMonthlyMailingOn = 'is_turn_monthly_mailing_on',
  ISTurnMonthlyMailingOff = 'is_turn_monthly_mailing_off',
  ISTurnOffersMailingOn = 'is_turn_offers_mailing_on',
  ISTurnOffersMailingOff = 'is_turn_offers_mailing_off',
  ISTurnInstantNotificationsOn = 'is_turn_instant_notifications_on',
  ISTurnInstantNotificationsOff = 'is_turn_instant_notifications_off',
  ISChangePasswordClick = 'is_change_password_click',
  ISChangePasswordDone = 'is_change_password_done',
  ISLogout = 'is_logout',
  ISOpenIssueDetail = 'is_open_issue_detail',
  ISOpenReturnDetail = 'is_open_return_detail',
  ISOpenPortfolio = 'is_open_portfolio',
  ISOpenReturns = 'is_open_returns',
  ISOpenUpdates = 'is_open_updates',
  ISOpenSettings = 'is_open_settings',
  ISReportMissingIssueClick = 'is_report_missing_issue_click',
  ISReportMissingIssueDone = 'is_report_missing_issue_done',
  ISCloseConfirmationScreen = 'is_close_confirmation_screen',
  ISOpenIssueManagement = 'is_open_issue_management',
  ISContactIssuerOpenClick = 'is_contact_issuer_open_click',
  ISContactIssuerOpenDone = 'is_contact_issuer_open_done',
  ISOpenPrematureReturnInfo = 'is_open_premature_return_info',
  ISOpenInvestmentTransferInfo = 'is_open_investment_transfer_info',
  ISForgotPasswordClick = 'is_forgot_password_click',
  ISCreateAccountClick = 'is_create_account_click',
  ISLoginClick = 'is_login_click',
  ISLoginDone = 'is_login_done',
  ISCallClick = 'is_call_click',
  ISForgotPasswordDone = 'is_forgot_password_done',
  ISEmailClick = 'is_email_click',
  ISLogoToHomepage = 'is_logo_to_homepage',
}
